import { Component, computed, input, inject } from "@angular/core";
import { ObjectInformation } from "src/app/shared/contract/ObjectInformation/ObjectInformation";
import { isSubObjectMainType } from "src/app/shared/helpers/object-subtype-helper";
import { ConversionService } from "src/app/shared/services/conversion.service";
import { TranslocoModule } from "@jsverse/transloco";
import { MatIconModule } from "@angular/material/icon";
import { FormsModule } from "@angular/forms";
import { TranslocoDecimalPipe } from "@jsverse/transloco-locale";
import { MatDivider } from "@angular/material/divider";

@Component({
  selector: "app-residential-popup-info",
  templateUrl: "./residential-popup-info.component.html",
  styleUrl: "./residential-popup-info.component.scss",
  imports: [TranslocoModule, MatIconModule, FormsModule, MatDivider, TranslocoDecimalPipe]
})
export class ResidentialPopupInfoComponent {
  private conversionService = inject(ConversionService);

  objectInformation = input<ObjectInformation>();
  priceTitle = input<string>();
  priceValue = input<number>();

  title = computed(() => {
    const objectInformation = this.objectInformation();

    if (!objectInformation) {
      return "-";
    }

    if (isSubObjectMainType(objectInformation.objectSubType)) {
      return "Module.ObjectInformation.ObjectType";
    }

    return "Module.ObjectInformation.ObjectSubType";
  });

  subtitle = computed(() => {
    const objectInformation = this.objectInformation();

    if (!objectInformation) {
      return "-";
    }

    if (isSubObjectMainType(objectInformation.objectSubType)) {
      const objectType = this.conversionService.convertObjectSubTypeToObjectType(objectInformation.objectSubType);
      return "Properties.ObjectType.LongVersion." + objectType;
    }

    return "Properties.ObjectSubType.LongVersion." + objectInformation.objectSubType;
  });
}
